import { RestSlice } from '../../../../redux/rest.slice';
import { IppDataProvider } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippDataProviderDetailSlice = new RestSlice<IppDataProvider>(
	localizationService.getLocalizedString('ipp.industryAccount.dataProviders.detailsPageHeading'),
	Resource.IppDataSources
);
export default ippDataProviderDetailSlice.rests.reducer;
